import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddOrderMutationVariables = Types.Exact<{
  input: Types.Orders_Insert_Input;
}>;


export type AddOrderMutation = { __typename?: 'mutation_root', insert_orders_one?: { __typename?: 'orders', id: any, workspace_id: any, status: string, total_amount?: any | null, notes?: string | null, created_at: any, updated_at: any, organization_id: any, user_id: string, organization?: { __typename?: 'organizations', id: any, name: string, email?: string | null } | null, user?: { __typename?: 'users', id: string, first_name: string, last_name: string } | null, items: Array<{ __typename?: 'order_items', id: any, order_id: any, quantity: any, unit_price?: any | null, total_price?: any | null, created_at: any, property_id: any, product_id: any, property?: { __typename?: 'properties', id: any, name: string } | null, product?: { __typename?: 'products', id: any, name: string, description: string, sku?: string | null, make: string, model: string, retail_price?: any | null, product_notes?: string | null, photo_link?: string | null, product_category: { __typename?: 'product_categories', name: string, label: string } } | null }> } | null };


export const AddOrderDocument = gql`
    mutation addOrder($input: orders_insert_input!) {
  insert_orders_one(object: $input) {
    id
    workspace_id
    status
    total_amount
    notes
    created_at
    updated_at
    organization_id
    organization {
      id
      name
      email
    }
    user_id
    user {
      id
      first_name
      last_name
    }
    items {
      id
      order_id
      quantity
      unit_price
      total_price
      created_at
      property_id
      property {
        id
        name
      }
      product_id
      product {
        id
        name
        description
        sku
        product_category {
          name
          label
        }
        make
        model
        retail_price
        product_notes
        photo_link
      }
    }
  }
}
    `;
export type AddOrderMutationFn = Apollo.MutationFunction<AddOrderMutation, AddOrderMutationVariables>;

/**
 * __useAddOrderMutation__
 *
 * To run a mutation, you first call `useAddOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrderMutation, { data, loading, error }] = useAddOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrderMutation(baseOptions?: Apollo.MutationHookOptions<AddOrderMutation, AddOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrderMutation, AddOrderMutationVariables>(AddOrderDocument, options);
      }
export type AddOrderMutationHookResult = ReturnType<typeof useAddOrderMutation>;
export type AddOrderMutationResult = Apollo.MutationResult<AddOrderMutation>;
export type AddOrderMutationOptions = Apollo.BaseMutationOptions<AddOrderMutation, AddOrderMutationVariables>;